import { Yup } from 'cng-web-lib'

function makeValidationSchema() {
  return Yup.object({
    clientCode: Yup.string()
    .when('module', {
      is: (value) => value == 'AES',
      then: Yup.string().max(9,"Max length allowed is 9").nullable(),
      otherwise: Yup.string().when('module', {
      is: (value) => value == 'FDA_PN',
      then: Yup.string().required('Client Code: Client Code is required.').max(3,"Max length allowed is 3"),
      otherwise: Yup.string().when('module', {
          is: (value) => value == 'SBCI',
          then: Yup.string().required('Client Code: Client Code is required.').max(10,"Max length allowed is 10"),
          otherwise: Yup.string().nullable().max(10,"Max length allowed is 10")
        }).nullable()
      }).nullable()
    }).nullable(),
    module: Yup.string().required('Client Code: Module is required.')
  })
}

export default makeValidationSchema
